<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    <path d="M5.357,8.144a.345.345,0,0,1-.064.4A1,1,0,1,0,6.707,9.957a2.37,2.37,0,0,0,.15-3.221c-.06-.1-.15-.252-.214-.38a.345.345,0,0,1,.064-.4A1,1,0,0,0,5.293,4.543a2.37,2.37,0,0,0-.15,3.221C5.2,7.865,5.293,8.016,5.357,8.144Z"/><path d="M17.143,6.736a2.37,2.37,0,0,0,.15,3.221,1,1,0,0,0,1.414-1.414.345.345,0,0,1-.064-.4c.064-.128.154-.279.214-.38a2.37,2.37,0,0,0-.15-3.221,1,1,0,0,0-1.414,1.414.345.345,0,0,1,.064.4C17.294,6.484,17.2,6.635,17.143,6.736Z"/><path d="M11.292,8.043a1,1,0,0,0,1.416,1.414c2.108-2.112.845-3.8.091-4.805s-.98-1.307-.092-2.2a1,1,0,0,0-1.414-1.414c-2.113,2.113-.85,3.8-.095,4.808S12.177,7.158,11.292,8.043Z"/><path d="M2.662,17.25H21.338a.5.5,0,0,0,.471-.668,2.9,2.9,0,0,0-.8-1.192,5.8,5.8,0,0,0-3.627-1.163,1,1,0,0,1-.825-.473A5.163,5.163,0,0,0,12,11.25a5.163,5.163,0,0,0-4.555,2.5,1,1,0,0,1-.825.473A5.793,5.793,0,0,0,2.993,15.39a2.9,2.9,0,0,0-.8,1.192.5.5,0,0,0,.471.668Z"/><path d="M23.25,18.5H.75a.75.75,0,0,0,0,1.5H1.766a1,1,0,0,1,.947.679l.59,1.742a1.491,1.491,0,0,0,1.342.829h14.71a1.51,1.51,0,0,0,1.369-.893l.565-1.677a1,1,0,0,1,.948-.68H23.25a.75.75,0,0,0,0-1.5Z"/>
  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'pasta-plate-warm',
    },
    name: {
      type: String,
      required: false,
      default: 'PastaPlateWarm',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>